import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

Sentry.init({
  dsn: 'https://ebab67862f71d8e5b2f153c7f3c28a75@o4511353712738304.ingest.de.sentry.io/4511353745702992',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  // sendDefaultPii omitted — this app handles pupil data; do not send IP addresses to Sentry
});

createRoot(document.getElementById('root')!).render(<App />);
